import React from 'react'
import {
  Build,
  Pause,
  PlayArrow,
  Edit,
  Delete,
  Forward,
  Close,
  Done,
  InfoOutlined,
} from '@material-ui/icons'
import ImportExportOutlinedIcon from '@material-ui/icons/ImportExportOutlined'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const actionsIcons = {
  activate: {
    icon: props => <Done {...props} />,
    tooltip: `Activar`,
  },
  pause: {
    icon: props => <Pause {...props} />,
    tooltip: `Pausar`,
  },
  play: {
    icon: props => <PlayArrow {...props} />,
    tooltip: `Publicar`,
  },
  upgrade: {
    icon: props => <Build {...props} />,
    tooltip: `Mejorar`,
  },
  edit: {
    icon: props => <Edit {...props} />,
    tooltip: `Editar`,
  },
  reject: {
    icon: props => <Build {...props} />,
    tooltip: `Rechazar`,
  },
  delete: {
    icon: props => <Delete {...props} />,
    tooltip: `Borrar`,
  },
  deleteUpgrade: {
    icon: props => <Delete {...props} className={`${props.className} deleteUpgrade`} />,
    tooltip: `Borrar Mejora`,
  },
  watch: {
    icon: props => <InfoOutlined {...props} />,
    tooltip: `Ver Información`,
  },
  validate: {
    icon: props => <Forward {...props} />,
    tooltip: `Validar`,
  },
  desactivate: {
    icon: props => <Close {...props} />,
    tooltip: `Desactivar`,
  },
  derivar: {
    icon: props => <ImportExportOutlinedIcon {...props} />,
    tooltip: `Derivar`,
  },
}

const styles = makeStyles(theme => ({
  iconBase: {
    transition: `0.3s`,
    '&:hover': {
      opacity: 0.5,
    },
  },
  enabledIcon: {
    fill: theme.palette.success.main,
    cursor: `pointer`,
    '&.deleteUpgrade': {
      fill: `#3D188E`,
    },
  },
  disabledIcon: {
    fill: theme.palette.gray[2],
  },
  tooltip: {
    background: `rgba(0, 0, 0, 0.7)`,
    padding: theme.spacing(0.5, 1),
    borderRadius: 5,
    color: theme.palette.primary.light,
  },
}))

export default function ActionIcon({ action, onChange, active = true, id, ...props }) {
  const classes = styles()
  const { icon: Icon, tooltip } = actionsIcons[action]
  return (
    <Tooltip title={<Typography className={classes.tooltip}>{tooltip}</Typography>} placement="top">
      {Icon({
        className: `${classes.iconBase} ${active ? classes.enabledIcon : classes.disabledIcon}`,
        onClick: active ? () => onChange({ action, experienceId: id, ...props }) : null,
      })}
    </Tooltip>
  )
}
